import { GifReader } from 'omggif'

/* eslint-disable no-plusplus */
/* eslint-disable no-continue */

/**
 * Адаптация https://github.com/themadcreator/gifler/ для нужд проекта
 */
export default class Gif {
  constructor(data, context, onDrawFrame) {
    this.data = data
    this.reader = new GifReader(new Uint8Array(data))
    this.ctx = context

    this.frameIndex = 0
    this.isLoaded = false
    this.running = false
    this.loopCount = this.reader.loopCount
    this.loops = 0
    this.width = this.reader.width
    this.height = this.reader.height
    this.onFrameCallback = null
    this.onEndCallback = null

    this.onDrawFrame = onDrawFrame
      || ((ctx, frame) => {
        ctx.drawImage(frame.buffer, frame.x, frame.y)
      })

    this.initFrames()
  }

  async initFrames() {
    this.frames = await this.decodeFrames()
    this.isLoaded = true
  }

  async decodeFrames() {
    const promises = []
    for (let i = 0; i < this.reader.numFrames(); i++) {
      promises.push(
        new Promise((resolve) => {
          const frameInfo = this.reader.frameInfo(i)
          frameInfo.pixels = new Uint8ClampedArray(
            this.reader.width * this.reader.height * 4,
          )
          this.reader.decodeAndBlitFrameRGBA(i, frameInfo.pixels)
          resolve(frameInfo)
        }),
      )
    }
    return Promise.all(promises)
  }

  static createBufferCanvas(frame, w, h) {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.width = frame.width
    canvas.height = frame.height

    const imageData = ctx.createImageData(w, h)
    imageData.data.set(frame.pixels)

    ctx.putImageData(imageData, -frame.x, -frame.y)
    return canvas
  }

  start() {
    this.lastTime = new Date().valueOf()
    this.delayCompensation = 0
    this.running = true

    setTimeout(this.nextFrame.bind(this), 0)
  }

  stop() {
    this.running = false
  }

  reset() {
    this.frameIndex = 0
    this.loops = 0
  }

  nextFrame() {
    this.mainTimeout = undefined
    requestAnimationFrame(this.nextFrameRender.bind(this))
  }

  nextFrameRender() {
    if (!this.running) {
      return null
    }
    this.onFrame()
    return this.enqueueNextFrame()
  }

  advanceFrame() {
    this.frameIndex += 1
    if (this.frameIndex >= this.frames.length) {
      if (this.loopCount !== 0 && this.loopCount === this.loops) {
        this.stop()
        if (this.onEndCallback) {
          this.onEndCallback()
        }
      } else {
        this.frameIndex = 0
        this.loops += 1
      }
    }
  }

  enqueueNextFrame() {
    this.advanceFrame()
    while (this.running) {
      const frame = this.frames[this.frameIndex]
      const delta = new Date().valueOf() - this.lastTime
      this.lastTime += delta
      this.delayCompensation += delta
      const frameDelay = frame.delay * 10
      const actualDelay = frameDelay - this.delayCompensation
      this.delayCompensation -= frameDelay
      if (actualDelay < 0) {
        this.advanceFrame()
        continue
      } else {
        setTimeout(this.nextFrame.bind(this), actualDelay)
        break
      }
    }
  }

  onFrame() {
    const frame = this.frames[this.frameIndex]
    if (!frame.buffer) {
      frame.buffer = Gif.createBufferCanvas(frame, this.width, this.height)
    }
    this.onDrawFrame(this.context, frame)
    if (this.onFrameCallback) {
      this.onFrameCallback()
    }
  }
}
